// @flow

import React, { Component } from 'react';

import Checkbox from '@mui/material/Checkbox';

import i18n from 'app/common/i18n';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import Button from 'app/common/button';

class CheckboxDialog extends Component {
  i18n: string => string;

  constructor(props) {
    super(props);

    const isArrayInput = /\[\]$/.test(props.name);
    const defaultValue = {};

    const value =
      (props.defaultValue &&
        (isArrayInput
          ? props.defaultValue.filter((t) => t.key === props.formKey)[0]
          : props.defaultValue)) ||
      defaultValue;

    const openModal = false;
    this.state = { value, openModal };
  }

  handleChange = (ev) => {
    const value = {
      ...this.state.value,
      key: this.props.formKey || this.state.value.key,
      [ev.target.name || ev.currentTarget.name]:
        ev.target.type === 'checkbox'
          ? ev.target.checked
          : Boolean(ev.currentTarget.value)
    };
    this.setState({ value, openModal: false });

    const proxyEvent = {
      target: {
        name: this.props.name,
        value: value,
        type: 'mixed'
      }
    };
    this.props.onChange(proxyEvent);
    this.props.removeError('consents');
  };

  handleOpen = (ev) => {
    ev.preventDefault();
    this.setState({ openModal: true });
  };

  handleClose = () => {
    this.setState({ openModal: false });
  };

  renderDialog() {
    const { value, openModal } = this.state;
    const { readOnly, getContent, title } = this.props;

    const valueKey = 'value';

    const actions = [
      <Button
        key="close"
        secondary
        flat
        name={valueKey}
        value={false}
        label={this.props.i18n('Close')}
        onClick={this.handleClose}
        style={{ marginLeft: '12px' }}
      />,
      <Button
        key="submit"
        primary
        autoFocus
        name={valueKey}
        value
        label={this.props.i18n('Accept')}
        onClick={this.handleChange}
        style={{ marginLeft: '12px' }}
      />
    ];

    return (
      <Dialog scroll="paper" onClose={this.handleClose} open={openModal}>
        <DialogTitle style={{ textTransform: 'capitalize' }}>
          {title}
        </DialogTitle>
        <DialogContent>{getContent()}</DialogContent>
        <DialogActions>{!readOnly ? actions : actions[0]}</DialogActions>
      </Dialog>
    );
  }

  render() {
    const { value, openModal } = this.state;
    const {
      defaultValue, // eslint-disable-line no-unused-vars
      onChange, // eslint-disable-line no-unused-vars
      name,
      error,
      errors,
      type,
      formKey,
      label,
      i18n,
      readOnly,
      title,
      getContent,
      removeError,
      ...props
    } = this.props;

    const valueKey = 'value';
    const errorStyles = error
      ? {
          border: '2px solid red',
          borderRadius: '4px',
          marginBottom: '4px'
        }
      : {};
    return (
      <>
        <label
          style={{ display: 'flex', alignItems: 'flex-start', ...errorStyles }}
        >
          <Checkbox
            color="primary"
            checked={Boolean(value[valueKey]) || false}
            name={valueKey}
            required
            readOnly={readOnly}
            onClick={!readOnly ? this.handleChange : undefined}
            {...props}
          />
          <span style={{ padding: '12px 0' }}>
            {typeof label === 'function'
              ? label({ handleOpen: this.handleOpen })
              : label}
          </span>
        </label>
        {openModal && this.renderDialog()}
      </>
    );
  }
}

export default i18n(CheckboxDialog);